export default "__VITE_ASSET__BsXPBYxp__"